import MqttServer from "./mqttUtil"
import { getDeviceData } from "./getData"

export const getGatewayStatus = (mqttServe: MqttServer, uuid: string) => {
  return new Promise((resolve, reject) => {
    mqttServe.sub(
      `/gateway/${uuid}/status`,
      (res: any) => {
        resolve(res)
      },
      1000
    )
  })
}

export const getDeviceStatus = (mqttServe: MqttServer, uuid: string, deviceId: number, type: string) => {
  return new Promise((resolve, reject) => {
    mqttServe.request(
      `/gateway/${uuid}`,
      { id: "device_status", action: "device_status", data: [deviceId] },
      (res: any) => {
        res = JSON.parse(res)
        if (res.code) {
          if (!res.data[0].status) {
            resolve("offline")
          } else if (type === "C002") {
            getDeviceData([{ device_id: deviceId, defines: ["Run_state"] }], mqttServe, uuid).then((res: any) => {
              try {
                const state = res.data[0].datas[0].value
                if (state.value == "3") {
                  resolve("warning")
                } else if (state.value == "4") {
                  resolve("fault")
                } else {
                  resolve("online")
                }
              } catch (e) {
                resolve("timeout")
              }
            })
          } else {
            resolve("online")
          }
        } else {
          resolve("fault")
        }
      }
    )
  })
}

// export const getStationStatus = async (mqttServe: MqttServer[], deviceList: Device[]) => {
//   for (let device of deviceList) {
//     const res = await getDeviceStatus(mqttServe[device.mqtt_server_id], device.iot_gateway_uuid, device.device_id)
//   }
// }
